"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appointmentEditRecordSchema = exports.appointmentEditPendingResponseSchema = exports.appointmentEditRequestSchema = exports.appointmentEditPreviewResponseSchema = exports.appointmentEditChangeSchema = void 0;
const zod_1 = require("zod");
const financial_correction_stage_response_1 = require("./financial-correction-stage.response");
const financial_payment_correction_request_1 = require("../request/financial-payment-correction.request");
/** One field of the change, as the approver reads it: names, never ids. `from` / `to` are display text ("—" for empty). */
exports.appointmentEditChangeSchema = zod_1.z.object({
    field: zod_1.z.string(),
    label: zod_1.z.string(),
    from: zod_1.z.string(),
    to: zod_1.z.string(),
});
/** "Would this edit be allowed, and what would it do?" - run before the clerk writes a reason, and again at request, verification and approval. */
exports.appointmentEditPreviewResponseSchema = zod_1.z.object({
    eligible: zod_1.z.boolean(),
    blockers: zod_1.z.array(zod_1.z.string()),
    appointmentId: zod_1.z.string().uuid(),
    appointmentNumber: zod_1.z.string().nullable(),
    patientName: zod_1.z.string(),
    changes: zod_1.z.array(exports.appointmentEditChangeSchema),
    effects: zod_1.z.array(zod_1.z.string()),
});
exports.appointmentEditRequestSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    status: financial_payment_correction_request_1.paymentCorrectionStatusEnum,
    appointmentId: zod_1.z.string().uuid(),
    appointmentNumber: zod_1.z.string().nullable(),
    patientUhid: zod_1.z.string().nullable(),
    patientName: zod_1.z.string(),
    changes: zod_1.z.array(exports.appointmentEditChangeSchema),
    reason: zod_1.z.string(),
    requestedBy: zod_1.z.string().uuid().nullable(),
    requestedByName: zod_1.z.string().nullable(),
    createdAt: zod_1.z.string(),
    stage: financial_correction_stage_response_1.correctionStageEnum,
    verifiedBy: zod_1.z.string().uuid().nullable(),
    verifiedByName: zod_1.z.string().nullable(),
    verifiedAt: zod_1.z.string().nullable(),
    verificationNote: zod_1.z.string().nullable(),
    approvedBy: zod_1.z.string().uuid().nullable(),
    approvedByName: zod_1.z.string().nullable(),
    approvedAt: zod_1.z.string().nullable(),
    decisionReason: zod_1.z.string().nullable(),
    appliedSummary: zod_1.z.array(zod_1.z.string()).nullable(),
    /** What approving would do TODAY, for a PENDING request - or why it can no longer be applied. Null once decided. */
    effects: zod_1.z.array(zod_1.z.string()).nullable().optional(),
});
exports.appointmentEditPendingResponseSchema = zod_1.z.object({
    pending: zod_1.z.boolean(),
    requestedByName: zod_1.z.string().nullable(),
    createdAt: zod_1.z.string().nullable(),
});
/**
 * THE APPOINTMENT AS THE EDIT FORM NEEDS IT: every editable value as it is on file (ids and the names to show), whether the caller may ask at
 * all, and - field by field - what is locked and why, so the dialog disables a control with the reason instead of letting the clerk find out at
 * Check.
 */
exports.appointmentEditRecordSchema = zod_1.z.object({
    appointmentId: zod_1.z.string().uuid(),
    appointmentNumber: zod_1.z.string().nullable(),
    status: zod_1.z.string(),
    lockVersion: zod_1.z.number().int(),
    /** The caller may ask for an edit of this appointment. When false, `blockers` says why (not their booking, closed ...). */
    canRequest: zod_1.z.boolean(),
    blockers: zod_1.z.array(zod_1.z.string()),
    /** Field (or field group) -> why it cannot be changed on this appointment. Keys: patient, department, doctor, slot, duration, payer, priority, mode, draft, channel, purpose, referral. */
    locks: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
    patientId: zod_1.z.string().uuid().nullable(),
    patientUhid: zod_1.z.string().nullable(),
    patientName: zod_1.z.string(),
    draft: zod_1.z.object({ givenName: zod_1.z.string(), familyName: zod_1.z.string().nullable(), mobile: zod_1.z.string() }).nullable(),
    departmentId: zod_1.z.string().uuid(),
    departmentName: zod_1.z.string(),
    /** A USER id (what `DoctorDto.userId` carries). */
    doctorId: zod_1.z.string().uuid(),
    doctorName: zod_1.z.string(),
    scheduledAt: zod_1.z.string(),
    slotNumber: zod_1.z.number().int().nullable(),
    /** `YYYY-MM-DD`, the slot's day - null for a same-day visit, which takes no slot. */
    slotDate: zod_1.z.string().nullable(),
    /** A future-day booking (it carries a number and a slot) as opposed to a same-day visit. */
    isReservation: zod_1.z.boolean(),
    durationMinutes: zod_1.z.number().int(),
    bookingChannelId: zod_1.z.string().uuid(),
    consultationMode: zod_1.z.string(),
    clinicalPurposeId: zod_1.z.string().uuid().nullable(),
    payerContext: zod_1.z.string(),
    finTariffId: zod_1.z.string().uuid().nullable(),
    finPackageId: zod_1.z.string().uuid().nullable(),
    patientReferralId: zod_1.z.string().uuid().nullable(),
    priority: zod_1.z.enum(['NORMAL', 'VIP', 'EMERGENCY']),
    /** The consultation receipt behind this appointment, if one exists. */
    receipt: zod_1.z.object({ invoiceNumber: zod_1.z.string(), status: zod_1.z.string() }).nullable(),
});
//# sourceMappingURL=financial-appointment-correction.response.js.map